import { frontendURL } from '../../helper/URLHelper';
import AgendaIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/agenda'),
    name: 'agenda_view',
    component: AgendaIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
];
